import React, { Component } from 'react'
import SaveStateButton from '../../general/SaveStateButton'
import config from '../../../config.json'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer'
import { ADVERTISEMENT_INTERSCROLLER, ADVERTISEMENT_OVERVIEW_BANNER, ADVERTISEMENT_OVERVIEW_HERO, ADVERTISEMENT_MAIN_SLIDER, ADVERTISEMENT_FIREPLACE, ADVERTISEMENT_HOME_BANNER } from '../../../constants/advertisementTypes'
import AdvertisementList from './AdvertisementList'
import sortCinemas from '../../../functions/sortCinemas'
import { WEISCHER_INTERSCROLLER, WEISCHER_OVERVIEW_HERO } from '../../../constants/weischerTypes'
import { SINGLECINEMA } from '../../../constants/cinemaTypes'



class PageAdvertisementPage extends Component {
    constructor(props) {
        super(props)

        this.state ={
            filteredData: this.getDefaultFilteredData()
        }
    }

    componentDidMount() {
        if(this.props.order.length > 0 ) {
            this.filterData()
        }
    }

    componentDidUpdate(prevProps) {
        if(
            JSON.stringify(prevProps.order) !== JSON.stringify(this.props.order) ||
            JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)
        ) {
            this.filterData()
        }
    }

    getDefaultFilteredData()  {
        const filteredData = {}

        const types = [
            ADVERTISEMENT_INTERSCROLLER, 
            ADVERTISEMENT_OVERVIEW_BANNER, 
            ADVERTISEMENT_OVERVIEW_HERO, 
            ADVERTISEMENT_MAIN_SLIDER,
            ADVERTISEMENT_FIREPLACE,
            ADVERTISEMENT_HOME_BANNER
        ]
        
        types.map(type => {
            filteredData[type] = {
                itemType: type,
                items: {},
                order: []
            }
        })

        return filteredData
    }

    filterData()  {
        const { order, items } = this.props
        const filteredData = this.getDefaultFilteredData()

        order.map(itemId => {
            const item =  items[itemId]
            const type = item.type

            if(filteredData.hasOwnProperty(type))  {
                filteredData[type].items[itemId] = item
                filteredData[type].order.push(itemId)
            }
        })

        this.setState({
            filteredData: structuredClone(filteredData)
        })
    }

    filterByType(itemsArray, type) {
        return itemsArray.filter(item => item && type === item.type)
    }

    render()  {
        const { programStatus, programError, weischerItems, addItem, editItem, deleteItem, onUpdateProgram, cinemaType, cliCinemas, clientCinemaId, closePagePath, adsConfig } = this.props
        const { filteredData } = this.state

        const weischerItemsArray = Object.values(weischerItems).filter(item => item.active)
        const weischerHeroItems = this.filterByType(weischerItemsArray, WEISCHER_OVERVIEW_HERO)
        const weisherInterscrollerItems = this.filterByType(weischerItemsArray, WEISCHER_INTERSCROLLER)
    
        const isSingleCinema = cinemaType === SINGLECINEMA
        const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)

        return (
            <WrapperPageSimple
                pageTitleTransId={config.routes.advertisement.transId}
                closePagePath={closePagePath}
                overlay={
                    <RequestOverlayContainer
                        programStatus={programStatus} 
                        programError={programError}
                    />
                }
            >
                <div className="site-content page-advertisements">
                    <AdvertisementList
                        data={filteredData[ADVERTISEMENT_MAIN_SLIDER]}
                        maxItems={false}
                        weischerItems={false}
                        titleTransId="advertisement_title_slider_elements"
                        buttonTransId="advertisement_button_new_ad_element_slider"
                        isSingleCinema={isSingleCinema}
                        cliCinemasIdList={cliCinemasIdList}
                        cliCinemas={cliCinemas}
                        addItem={addItem}
                        editItem={editItem}
                        deleteItem={deleteItem}
                    />
                    
                    <AdvertisementList
                        data={filteredData[ADVERTISEMENT_HOME_BANNER]}
                        maxItems={false}
                        weischerItems={false}
                        titleTransId="advertisement_title_advertisement_slider_elements"
                        buttonTransId="advertisement_button_new_ad_element_slider"
                        isSingleCinema={isSingleCinema}
                        cliCinemasIdList={cliCinemasIdList}
                        cliCinemas={cliCinemas}
                        addItem={addItem}
                        editItem={editItem}
                        deleteItem={deleteItem}
                    />

                    <AdvertisementList
                        data={filteredData[ADVERTISEMENT_OVERVIEW_HERO]}
                        maxItems={1}
                        weischerItems={weischerHeroItems.length}
                        titleTransId="weischer_title_program_overview_hero"
                        buttonTransId="advertisement_button_new_ad_element_hero"
                        isSingleCinema={isSingleCinema}
                        cliCinemasIdList={cliCinemasIdList}
                        cliCinemas={cliCinemas}
                        addItem={addItem}
                        editItem={editItem}
                        deleteItem={deleteItem}
                    />
    
                    <AdvertisementList
                        data={filteredData[ADVERTISEMENT_OVERVIEW_BANNER]}
                        maxItems={3}
                        weischerItems={false}
                        titleTransId="weischer_title_program_overview_tiles"
                        buttonTransId="advertisement_button_new_ad_element_program_overview"
                        isSingleCinema={isSingleCinema}
                        cliCinemasIdList={cliCinemasIdList}
                        cliCinemas={cliCinemas}
                        addItem={addItem}
                        editItem={editItem}
                        deleteItem={deleteItem}
                    />
    
                    <AdvertisementList
                        data={filteredData[ADVERTISEMENT_INTERSCROLLER]}
                        maxItems={1}
                        weischerItems={weisherInterscrollerItems.length}
                        titleTransId="weischer_title_program_overview_interscroller"
                        buttonTransId="advertisement_button_new_ad_interscroller"
                        isSingleCinema={isSingleCinema}
                        cliCinemasIdList={cliCinemasIdList} 
                        cliCinemas={cliCinemas}
                        addItem={addItem}
                        editItem={editItem}
                        deleteItem={deleteItem}
                    />

                    {adsConfig && adsConfig.advertisements_fireplace && <AdvertisementList
                        data={filteredData[ADVERTISEMENT_FIREPLACE]}
                        maxItems={1}
                        titleTransId="advertisements_title_fireplace"
                        buttonTransId="advertisement_button_new_ad_fireplace"
                        isSingleCinema={isSingleCinema}
                        cliCinemasIdList={cliCinemasIdList} 
                        cliCinemas={cliCinemas}
                        addItem={addItem}
                        editItem={editItem}
                        deleteItem={deleteItem}
                    />}
                </div>
    
                <div className="save-program-button">
                    <SaveStateButton
                        status={programStatus}
                        transId="update_button"
                        condition={true}
                        saveState={onUpdateProgram}
                    />
                </div>
            </WrapperPageSimple>
        )
    }
}

export default PageAdvertisementPage

